module.exports = __webpack_public_path__ + "static/media/store2.1e5c7f47.svg";